import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SelectButtonChangeEvent } from 'primeng/selectbutton';
import { DocumentiService } from 'src/app/core/documenti.service';
import { DocumentiListColumnNames } from 'src/app/shared/components/documenti-list/documenti-list.model';
import { DocumentiSearchRequest, DocumentiSearchResponse } from 'src/app/shared/models/documento-search.model';
import { StatoTabellaElenchi } from 'src/app/shared/models/stato.model';

@Component({
  selector: 'app-elenchi',
  template: `
  <div class="card card-w-title">
    <h1>Elenchi</h1>
    <form class="marginBottom10" [formGroup]="formSelectedState">
      <p-selectButton [options]="states" formControlName="state" (onChange)="setSelectedState($event)">
      </p-selectButton>
    </form>
    <app-documenti-list [data]="searchResponse" [activeColumns]="columns"
      (updateRequestAndSearch)="updateRequestAndSearch($event)">
    </app-documenti-list>
  </div>
  `,
  styles: [`.marginBottom10 { margin-bottom: 10px; }`]
})
export class ElenchiComponent implements OnInit {
  public states: StatoTabellaElenchi[] = [];
  public formSelectedState!: FormGroup;

  public searchResponse = { originalRequest: { pageFirstRow: 0, pageSize: 20, sortField: 'DataDocumento', sortOrder: 1 } } as DocumentiSearchResponse;
  public columns: DocumentiListColumnNames = ['PosizioneId', 'Protocollo', 'DataDocumento', 'Arrivo', 'Oggetto', 'StatoUtente', 'ActionButtons'];

  constructor(private fb: FormBuilder, private documentiService: DocumentiService) { }

  ngOnInit(): void {
    this.states = [
      { label: 'Documenti in trattazione', value: 'Trattazione' },
      { label: 'Documenti in firma', value: 'Firma' },
      { label: 'Documenti in visione', value: 'Visione' },
      { label: 'Documenti protocollati in giornata', value: 'Protocollo' }
    ];

    const defaultState = this.states[0].value;

    this.formSelectedState = this.fb.group({
      state: new FormControl(defaultState)
    });

    this.search(defaultState);
  }

  setSelectedState(event: SelectButtonChangeEvent): void {
    this.search(event.value as string);
  }

  search(state: string): void {
    const request = {
      pageFirstRow: 0,
      filters: {}
    } as DocumentiSearchRequest;

    if (state === 'Protocollo') {
      request.filters.dataProtocollazione = new Date();
    } else {
      request.filters.statoGruppo = state;
    }

    this.updateRequestAndSearch(request);
  }

  updateRequestAndSearch(request: DocumentiSearchRequest | null): void {
    if (!request) return;

    const mergedRequest = { ...this.searchResponse.originalRequest, ...request };
    this.documentiService.search(mergedRequest).subscribe(response => this.searchResponse = response);
  }
}
